import { Roles } from "app/models/user"
import { useSelector } from "react-redux"
import { getAccessRoles } from "app/redux/authorization/authorization.selectors"
import { userAndTokenDispatched } from "app/redux/currentUser/currentUser.selectors"
import { arraysIntersect } from "utils"

interface IUseAccessRoles {
  isAllowed: boolean
  hasUserAndToken: boolean
}
export default function useAccessRoles(allowedRoles?: Roles[]): IUseAccessRoles {
  const accessRoles = useSelector(getAccessRoles)
  const hasUserAndToken = useSelector(userAndTokenDispatched)
  const isAllowed = !allowedRoles || arraysIntersect(allowedRoles, accessRoles)
  return { isAllowed, hasUserAndToken }
}

export function useIsManager() {
  const isManager = useAccessRoles([Roles.Planner, Roles.HROfficer])
  return isManager
}
